import { useSelector } from 'react-redux';

import { dateFormat } from 'common/helpers/dateHelper';

import { isUpcomingCancel } from '../helpers';

const UpcomingCancelMessage = (props) => {
  const { clubMembership } = props;
  const settings = useSelector((state) => state.setting);

  const isFuture = isUpcomingCancel(clubMembership);
  if (!isFuture) {
    return null;
  }
  return (
    <>
      Your club will be cancelled on{' '}
      {dateFormat(clubMembership.cancelDate, settings)}
      <br />
    </>
  );
};

export default UpcomingCancelMessage;
